// LA EDAD DEL PACIENTE, EN EL NAVEGADOR. Espejo de backend/services/edadPaciente.js.
//
// Vive aqui para que una pantalla pueda decidir que enseñar sin ir al servidor por cada tecla. NO
// decide nada que importe: quien manda es siempre el servidor.
//
// EL DNI NO ES OBLIGATORIO HASTA LOS 14 (art. 9.1 LO 4/2015 y RD 1553/2005). Exigirlo igual no
// consigue que el niño lo tenga: consigue que en su ficha acabe el DNI de su padre o de su madre.
//
// NUNCA `new Date(cadena)` ni `toISOString()`: sobre un nacimiento del dia 4 devuelven el dia 3, y
// quien cumple hoy sale con un año de menos. La cadena se lee con una expresion regular, que es la
// unica forma de que no intervenga ninguna zona horaria.

export const EDAD_DNI_OBLIGATORIO = 14;
export const EDAD_MAYORIA = 18;   // para FIRMAR. Otra cosa distinta: no confundirlas.
// Por debajo de esta edad, un documento lo autoriza su REPRESENTANTE LEGAL: con 16 cumplidos ya no
// cabe el consentimiento por representacion salvo grave riesgo (Ley 41/2002, art. 9.4). Es el mismo
// numero que services/representanteLegal.EDAD_SIN_REPRESENTACION en el servidor.
//
// SON TRES UMBRALES DISTINTOS Y NO SE MEZCLAN: 14 = tener DNI propio; 16 = quien AUTORIZA un
// documento; 18 = mayoria de edad. Un chico de 15 tiene DNI y sigue necesitando a su representante.
export const EDAD_SIN_REPRESENTACION = 16;
// (19-oct-2026) EL DNI DEL MENOR NO SE PIDE HASTA LOS 16: por debajo, la ficha pide a su representante legal, y el documento
// del menor es opcional (un menor de 16 puede no tenerlo aún). Espejo de services/edadPaciente · EDAD_DNI_NO_SE_PIDE. El 14
// de arriba sigue para lo que es la ley (la letra del DNI: «lo más probable es que ese número sea el de su padre»).
export const EDAD_DNI_NO_SE_PIDE = EDAD_SIN_REPRESENTACION;

// t599 · B-2260 · EN UNA CLÍNICA DE ANIMALES (la veterinaria) LA FICHA ESTÁ SIEMPRE REPRESENTADA por su titular, tenga los años
// que tenga el animal: el animal nunca firma ni tiene documento. Lo apunta utils/tipoNegocio · ponerTipoNegocio con el tipo de la
// clínica de quien mira (solo llega con la función «tipos-de-negocio» encendida). Espejo de services/representanteFicha · leer
// (`animal`). Fuera de una clínica de animales es false y todo lo de abajo es lo de siempre.
// (Se mira con `typeof` dentro de cada función: hay guardias que ejecutan el CUERPO de esas funciones a solas, sin el módulo.)
let _siempreRepresentado = false;
export function ponerSiempreRepresentado(si) { _siempreRepresentado = si === true; }
export const siempreRepresentado = () => _siempreRepresentado;

/** ¿Es menor de 16 y por tanto NO se le pide su DNI en la ficha ni en el pre-registro? `false` si no se sabe la edad. */
export function noSePideDniDelMenor(fecNacim, hoy = new Date()) {
  if (typeof _siempreRepresentado !== 'undefined' && _siempreRepresentado === true) return true;   // t599 · al animal no se le pide documento
  const e = edadDesdeFecha(fecNacim, hoy);
  return e != null && e < EDAD_DNI_NO_SE_PIDE;
}

/** Edad en años a partir de 'YYYY-MM-DD' (o un Date). null cuando no se puede saber. */
export function edadDesdeFecha(v, hoy = new Date()) {
  if (!v) return null;
  let a, m, d;
  if (v instanceof Date) {
    if (isNaN(v.getTime())) return null;
    a = v.getFullYear(); m = v.getMonth() + 1; d = v.getDate();
  } else {
    const x = String(v).match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (!x) return null;
    a = +x[1]; m = +x[2]; d = +x[3];
  }
  let e = hoy.getFullYear() - a;
  const dm = (hoy.getMonth() + 1) - m;
  if (dm < 0 || (dm === 0 && hoy.getDate() < d)) e--;
  return e >= 0 && e < 130 ? e : null;
}

/**
 * ¿Es menor de 14 y por tanto NO esta obligado a tener DNI?
 * `false` tambien cuando no se sabe la edad: aqui nunca se supone. Sin fecha, todo sigue igual.
 */
export function esMenorSinDniObligatorio(fecNacim, hoy = new Date()) {
  if (typeof _siempreRepresentado !== 'undefined' && _siempreRepresentado === true) return true;   // t599 · el animal no tiene DNI
  const e = edadDesdeFecha(fecNacim, hoy);
  return e != null && e < EDAD_DNI_OBLIGATORIO;
}

/**
 * ¿Hay que pedir el representante legal? Solo por debajo de 16.
 *
 * `false` tambien cuando no se sabe la edad, igual que su hermana de arriba: no saber la edad no es
 * lo mismo que saber que es menor, y exigirlo a ciegas atascaria a media clinica por fichas antiguas
 * sin fecha de nacimiento.
 */
export function pideRepresentanteLegal(fecNacim, hoy = new Date()) {
  if (typeof _siempreRepresentado !== 'undefined' && _siempreRepresentado === true) return true;   // t599 · el titular del animal, siempre
  const e = edadDesdeFecha(fecNacim, hoy);
  return e != null && e < EDAD_SIN_REPRESENTACION;
}
